import { BlpImage as Image } from './image';

export default {
  Image,
};
